export default {
  data() {
    return {
      sourceList: ["原创", "网络", "翻译", "购买", "改编", "其他"], // 来源 1 原创； 2 网络； 3 翻译； 4 购买； 5 改编； 6 其他
      typeList: ["编程题"],
      languagesList: [
        "JavaScript",
        "Python 3.7",
        "Mysql 8",
        "Java",
        "Node",
        "C++",
        "Oracle",
        "Shell"
      ],
      support: {
        "Python 3.7": "python",
        "Mysql 8": "mysql",
        Java: "java",
        Node: "node",
        JavaScript: "node",
        "C++": "cpp",
        Oracle: "oracle",
        Shell: "shell"
      }
    };
  },
  computed: {
    getStatus() {
      return (status, type) => {
        let color, content;
        switch (status) {
          case 1:
            color = "#E6A23C";
            content = "已提交";
            break;
          case 2:
            content = "已通过";
            color = "#67C23A";
            break;
          case 3:
            content = "已拒绝";
            color = "#F56C6C";
            break;
          case 4:
            content = "废弃";
            color = "#909399";
            break;
        }
        return type == "color" ? color : content;
      };
    },
    getInput() {
      return input => {
        let val = null;
        const len = input.length - 1;
        input.forEach((item, index) => {
          if (index == 0) {
            val = `{${item.key}:${item.value},`;
          } else if (index == len) {
            val += `${item.key}:${item.value}}`;
          } else {
            val += `${item.key}:${item.value},`;
          }
        });
        return val;
      };
    },
    getLanguage() {
      let lan;
      for (let key in this.support) {
        if (key == this.currentLanguage.name) {
          lan = this.support[key];
        }
      }
      return lan;
    }
  }
};
